import { BorderRadius, Color, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const ComingSoonItem = styled.div`
  display: flex;
  flex: 1;
  gap: ${Spacing.S12};
  padding: ${Spacing.S16};
  border: 1px solid ${Color.Grey200};
  border-radius: ${BorderRadius.R16};
  text-align: left;
`
